/* FURLLO review form progressive enhancement: the Judge.me service remains the only reviewer data processor. */
(function(){
  'use strict';
  if(!document.documentElement.classList.contains('template-product') && !document.body.classList.contains('template-product')) return;
  var lastProduct=null;
  function install(){
    var section=document.querySelector('.furllo-real-product-reviews');
    var pImage=section && section.querySelector('.furllo-review-featured-image img');
    var pName=section && section.querySelector('.furllo-review-featured-copy strong');
    if(!pName) return;
    var productName=pName.textContent.trim();
    var allForms=document.querySelectorAll('.jdgm-widget .jdgm-form');
    allForms.forEach(function(form){
      form.querySelectorAll('input[type=file],input[name=yt_url]').forEach(function(input){input.disabled=true});
      // Judge.me uses multiple upload-field wrappers across versions.
      form.querySelectorAll('fieldset, .jdgm-form__fieldset, .jdgm-form__fieldset-media, .jdgm-form__fieldset--media, .jdgm-form__media-fieldset, .jdgm-form__fieldset--picture').forEach(function(field){
        var txt=(field.textContent||'').replace(/\s+/g,' ').trim();
        if(txt.length<130 && (/Picture\/Video\s*\(optional\)/i.test(txt)||/^Picture\/Video/i.test(txt)||/^YouTube URL/i.test(txt))){
          field.hidden=true;field.style.setProperty('display','none','important');
          field.querySelectorAll('input,button').forEach(function(el){el.disabled=true});
        }
      });
      form.querySelectorAll('input[placeholder*=YouTube],input[placeholder*=Youtube]').forEach(function(input){input.disabled=true;var wrap=input.closest('.jdgm-form__fieldset')||input.parentElement;if(wrap){wrap.hidden=true;wrap.style.setProperty('display','none','important')}});
      if(form.querySelector('.furllo-form-product-selection') || !pImage) return;
      var banner=document.createElement('div');banner.className='furllo-form-product-selection';
      var img=document.createElement('img');img.src=pImage.currentSrc||pImage.src;img.alt=productName;img.loading='lazy';
      var content=document.createElement('div'),label=document.createElement('span'),name=document.createElement('strong');
      label.textContent='Selected product';name.textContent=productName;
      content.append(label,name);banner.append(img,content);
      var title=form.querySelector('.jdgm-form__title');
      if(title&&title.parentNode)title.insertAdjacentElement('afterend',banner);
      else form.prepend(banner);
    });
  }
  var running=false;
  function schedule(){if(running)return;running=true;requestAnimationFrame(function(){running=false;install()})}
  var obs=new MutationObserver(schedule);
  obs.observe(document.body,{childList:true,subtree:true});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
})();
